export enum AutomationTrigger {
  NEW_CONTACT = "new_contact",
  CONTACT = "contact",
}
